
import clientAxios from "../client";

import { formatQueryString } from "@/common/utils/common";

import type { QueryType } from "@/common/types/common";
import type {
    CollectionManufacturerType,
    CollectionManufacturerPayloadType,
} from "@/common/types/collection-manufacturer";

export async function collectionManufacturerList(
    collection_id: string,
    query?: QueryType
) {
    const queryString = formatQueryString(query);

    return await clientAxios.get(
        `collection/${collection_id}/manufacturer/list${queryString}`
    );
}

export async function collectionManufacturerGet(
    item_id: string
) {
    return await clientAxios.get(
        `collection/manufacturer/${item_id}/show`
    );
}

export async function collectionManufacturerCreate(
    collection_id: string,
    payload: CollectionManufacturerPayloadType
) {
    return await clientAxios.post(
        `collection/${collection_id}/manufacturer/create`,
        payload
    );
}

export async function collectionManufacturerPatch(
    item_id: string,
    payload: Partial<CollectionManufacturerType>
) {
    return await clientAxios.patch(
        `collection/manufacturer/${item_id}/patch`,
        { payload }
    );
}

export async function collectionManufacturerDel(
    item_id: string,
) {
    return await clientAxios.del(
        `collection/manufacturer/${item_id}/delete`,
    );
}
